import { Denomination } from "../Denomination";
import { AlarmFlagsEnum } from "../enums/AlarmFlagsEnum";
import { DelayTypeEnum } from "../enums/DelayTypeEnum";
import { StockTypeEnum } from "../enums/StockTypeEnum";
import { TimeBandFlagsEnum } from "../enums/TimeBandFlagEnum";

export class Configuration {
    alarms: Array<AlarmFlagsEnum>;
    delays: Array<DelayConfiguration>;
    timeBands: Array<TimeBands>;
    rollsConfig: Array<Stock>;

    constructor() {}

    public isEqual(other: Configuration, compareSecurity) {
        if (compareSecurity) {
            if ((!this.alarms && other.alarms && other.alarms.length > 0) || (this.alarms && this.alarms.length > 0 && !other.alarms)) return false;
            if (this.alarms && other.alarms) {
                if (this.alarms.length != other.alarms.length) return false;
                for (let alarm of this.alarms) {
                    if (!other.alarms.includes(alarm)) return false;
                }
                for (let alarm of other.alarms) {
                    if (!this.alarms.includes(alarm)) return false;
                }
            }
            if ((!this.delays && other.delays && other.delays.length > 0) || (this.delays && this.delays.length > 0 && !other.delays)) return false;
            if (this.delays && other.delays) {
                if (this.delays.length != other.delays.length) return false;
                for (let delay of this.delays) {
                    if (other.delays.filter((d) => d.delay == delay.delay && d.amount == delay.amount && d.type == delay.type && d.options == delay.options).length == 0)
                        return false;
                }
                for (let delay of other.delays) {
                    if (this.delays.filter((d) => d.delay == delay.delay && d.amount == delay.amount && d.type == delay.type && d.options == delay.options).length == 0)
                        return false;
                }
            }
            if ((!this.timeBands && other.timeBands && other.timeBands.length > 0) || (this.timeBands && this.timeBands.length > 0 && !other.timeBands)) return false;
            if (this.timeBands && other.timeBands) {
                if (this.timeBands.length != other.timeBands.length) return false;

                for (let timeBand of this.timeBands) {
                    if (
                        other.timeBands.filter(
                            (t) =>
                                t.endDay == timeBand.endDay &&
                                t.startDay == timeBand.startDay &&
                                t.options == timeBand.options &&
                                t.endTime == timeBand.endTime &&
                                t.startTime == timeBand.startTime
                        ).length == 0
                    )
                        return false;
                }
                for (let timeBand of other.timeBands) {
                    if (
                        this.timeBands.filter(
                            (t) =>
                                t.endDay == timeBand.endDay &&
                                t.startDay == timeBand.startDay &&
                                t.options == timeBand.options &&
                                t.endTime == timeBand.endTime &&
                                t.startTime == timeBand.startTime
                        ).length == 0
                    )
                        return false;
                }
            }
        } else {
            if ((!this.rollsConfig && other.rollsConfig && other.rollsConfig.length > 0) || (this.rollsConfig && this.rollsConfig.length > 0 && !other.rollsConfig)) return false;
            if (this.rollsConfig && other.rollsConfig) {
                if (this.rollsConfig.length != other.rollsConfig.length) return false;
                for (let rollConfig of this.rollsConfig) {
                    if (
                        other.rollsConfig.filter(
                            (r: Stock) =>
                                r.cashIn == rollConfig.cashIn &&
                                r.counterfeit == rollConfig.counterfeit &&
                                r.denominationIsEqual(rollConfig.denominations) &&
                                r.exceed == rollConfig.exceed &&
                                r.index == rollConfig.index &&
                                r.stockType == rollConfig.stockType &&
                                r.suspect == rollConfig.suspect &&
                                r.unfit == rollConfig.unfit
                        ).length == 0
                    )
                        return false;
                }

                for (let rollConfig of other.rollsConfig) {
                    if (
                        this.rollsConfig.filter(
                            (r: Stock) =>
                                r.cashIn == rollConfig.cashIn &&
                                r.counterfeit == rollConfig.counterfeit &&
                                r.denominationIsEqual(rollConfig.denominations) &&
                                r.exceed == rollConfig.exceed &&
                                r.index == rollConfig.index &&
                                r.stockType == rollConfig.stockType &&
                                r.suspect == rollConfig.suspect &&
                                r.unfit == rollConfig.unfit
                        ).length == 0
                    )
                        return false;
                }
            }
        }

        return true;
    }

    public parse(obj: any) {
        if (obj.Alarms) {
            this.alarms = new Array<AlarmFlagsEnum>();
            obj.Alarms.forEach((alarm) => {
                this.alarms.push(alarm);
            });
        }

        if (obj.Delays) {
            this.delays = new Array<DelayConfiguration>();
            obj.Delays.forEach((delay) => {
                let del = new DelayConfiguration();
                del.parse(delay);
                this.delays.push(del);
            });
        }

        if (obj.TimeBands) {
            this.timeBands = new Array<TimeBands>();
            obj.TimeBands.forEach((band) => {
                let b = new TimeBands();
                b.parse(band);
                this.timeBands.push(b);
            });
        }

        if (obj.RollsConfig) {
            this.rollsConfig = new Array<Stock>();
            obj.RollsConfig.forEach((roll) => {
                let r = new Stock();
                r.parse(roll);
                this.rollsConfig.push(r);
            });
        }
    }

    public clone(obj: Configuration) {
        if (obj.alarms == null || obj.alarms == undefined) this.alarms = obj.alarms;
        else {
            this.alarms = new Array<AlarmFlagsEnum>();
            obj.alarms.forEach((alarm) => {
                this.alarms.push(alarm);
            });
        }

        if (obj.delays == null || obj.delays == undefined) this.delays = obj.delays;
        else {
            this.delays = new Array<DelayConfiguration>();
            obj.delays.forEach((delay) => {
                let del = new DelayConfiguration();
                del.clone(delay);
                this.delays.push(del);
            });
        }

        if (obj.timeBands == null || obj.timeBands == undefined) this.timeBands = obj.timeBands;
        else {
            this.timeBands = new Array<TimeBands>();
            obj.timeBands.forEach((band) => {
                let b = new TimeBands();
                b.clone(band);
                this.timeBands.push(b);
            });
        }

        if (obj.rollsConfig == null || obj.rollsConfig == undefined) this.rollsConfig = obj.rollsConfig;
        else {
            this.rollsConfig = new Array<Stock>();
            obj.rollsConfig.forEach((roll) => {
                let r = new Stock();
                r.clone(roll);
                this.rollsConfig.push(r);
            });
        }
        return this;
    }
}

export class DelayConfiguration {
    type: DelayTypeEnum;
    delay: number;
    options: number;
    amount: number;

    public parse(obj: any) {
        if (obj.Type != null || obj.Type != undefined) this.type = obj.Type;
        if (obj.Delay != null || obj.Delay != undefined) this.delay = obj.Delay;
        if (obj.Options != null || obj.Options != undefined) this.options = obj.Options;
        if (obj.Amount != null || obj.Amount != undefined) this.amount = obj.Amount;
    }

    public clone(obj: DelayConfiguration) {
        this.type = obj.type;
        this.delay = obj.delay;
        this.options = obj.options;
        this.amount = obj.amount;
    }
}

export class TimeBands {
    startDay: number;
    endDay: number;
    startTime: string;
    endTime: string;
    options: TimeBandFlagsEnum;

    public parse(obj: any) {
        if (obj.StartDay != null || obj.StartDay != undefined) this.startDay = obj.StartDay;
        if (obj.EndDay != null || obj.EndDay != undefined) this.endDay = obj.EndDay;
        if (obj.StartTime != null || obj.StartTime != undefined) this.startTime = obj.StartTime;
        if (obj.EndTime != null || obj.EndTime != undefined) this.endTime = obj.EndTime;
        if (obj.Options != null || obj.Options != undefined) this.options = obj.Options;
    }

    public clone(obj: any) {
        this.startDay = obj.startDay;
        this.endDay = obj.endDay;
        this.startTime = obj.startTime;
        this.endTime = obj.endTime;
        this.options = obj.options;
    }
}

export class Stock {
    stockType: StockTypeEnum;
    index: number;
    cashIn: boolean;
    exceed: boolean;
    unfit: boolean;
    counterfeit: boolean;
    suspect: boolean;
    denominations: Array<Denomination>;

    public parse(obj: any) {
        if (obj.StockType != null || obj.StockType != undefined) this.stockType = obj.StockType;
        if (obj.Index != null || obj.Index != undefined) this.index = obj.Index;
        if (obj.CashIn != null || obj.CashIn != undefined) this.cashIn = obj.CashIn;
        if (obj.Exceed != null || obj.Exceed != undefined) this.exceed = obj.Exceed;
        if (obj.Unfit != null || obj.Unfit != undefined) this.unfit = obj.Unfit;
        if (obj.Counterfeit != null || obj.Counterfeit != undefined) this.counterfeit = obj.Counterfeit;
        if (obj.Suspect != null || obj.Suspect != undefined) this.suspect = obj.Suspect;
        if (obj.Denominations) {
            this.denominations = new Array<Denomination>();
            obj.Denominations.forEach((den) => {
                let d = new Denomination();
                d.parse(den);
                this.denominations.push(d);
            });
        }
    }

    public clone(obj: Stock) {
        this.stockType = obj.stockType;
        this.index = obj.index;
        this.cashIn = obj.cashIn;
        this.exceed = obj.exceed;
        this.unfit = obj.unfit;
        this.counterfeit = obj.counterfeit;
        this.suspect = obj.suspect;
        if (obj.denominations) {
            this.denominations = new Array<Denomination>();
            obj.denominations.forEach((den) => {
                let d = new Denomination();
                d.clone(den);
                this.denominations.push(d);
            });
        }
    }

    public denominationIsEqual(other: Array<Denomination>) {
        for (let denomination of this.denominations) {
            if (other.filter((d) => d.IsEqualsWithRevision(denomination)).length == 0) return false;
        }
        for (let denomination of other) {
            if (this.denominations.filter((d) => d.IsEqualsWithRevision(denomination)).length == 0) return false;
        }
        return true;
    }
}
